export default __webpack_public_path__ + "static/media/Support.88a1d809.svg";